import { render, staticRenderFns } from "./AppFormInput.vue?vue&type=template&id=3ffb1c35&scoped=true&"
import script from "./AppFormInput.vue?vue&type=script&lang=ts&"
export * from "./AppFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./AppFormInput.vue?vue&type=style&index=0&id=3ffb1c35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb1c35",
  null
  
)

export default component.exports